import $ from 'jquery';

const $html = $('html');
const $toggleSearchFilters = $('.js-search-panel-toggle');
const $searchPanel = $('.js-search-panel');
const $searchPanelHandle = $('.js-search-panel-handle');
let panelHeight; // in vh

const openPanel = () => {
    $toggleSearchFilters.addClass('is-open');
    $searchPanel.addClass('is-open');
    $html.addClass('panel-open');
};
const closePanel = () => {
    $toggleSearchFilters.removeClass('is-open');
    $searchPanel.removeClass('is-open');
    $searchPanel.on('transitionend', () => {
        $searchPanel.off('transitionend');
        $searchPanel.height('');
    });
    $html.removeClass('panel-open');
};

$toggleSearchFilters.on('click', () => {
    if ($toggleSearchFilters.hasClass('is-open')) {
        closePanel();
    } else {
        openPanel();
    }
});
$(document).on('click', (e) => {
    if (!$(e.target).closest($searchPanel).length
    && !$(e.target).closest($toggleSearchFilters).length) {
        closePanel();
    }
});

const setPanelHeight = (value) => {
    panelHeight = Math.max(0, Math.min(100, value));
    $searchPanel.height(`${panelHeight}vh`);
};

const touchPosition = (event) => (event.touches ? event.touches[0] : event);

let dragPosition;

const onDragStart = (event) => {
    dragPosition = touchPosition(event).pageY;
    $searchPanelHandle.css('cursor', 'grabbing');
};
const onDragMove = (event) => {
    if (dragPosition === undefined) return;

    const y = touchPosition(event).pageY;
    const deltaY = dragPosition - y;
    const deltaHeight = (deltaY / window.innerHeight) * 100;
    setPanelHeight(panelHeight + deltaHeight);
    dragPosition = y;
};

const onDragEnd = () => {
    dragPosition = undefined;
    $searchPanelHandle.css('cursor', '');
    if (window.innerWidth < 1024) {
        if (panelHeight < 70) {
            closePanel();
        } else {
            setPanelHeight(84);
        }
    }
};

$searchPanelHandle.on('mousedown', onDragStart);
$searchPanelHandle.on('touchstart', onDragStart);

window.addEventListener('mousemove', onDragMove);
window.addEventListener('touchmove', onDragMove);

window.addEventListener('mouseup', onDragEnd);
window.addEventListener('touchend', onDragEnd);
